export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4 whitespace-nowrap">
              移动端观看
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              随时随地 · 高清在线
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              91麻豆免费视频网站完美适配移动端浏览器，无需下载APP，打开即可畅享91高清视频在线观看。自适应码率技术确保手机流量环境下依然流畅播放，随时随地享受超清视频在线观看体验。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5 bg-background-100 px-3 py-1.5 rounded-full">
                <i className="ri-smartphone-line text-primary-500"></i>
                iOS Safari 适配
              </span>
              <span className="flex items-center gap-1.5 bg-background-100 px-3 py-1.5 rounded-full">
                <i className="ri-android-line text-primary-500"></i>
                Android Chrome 适配
              </span>
              <span className="flex items-center gap-1.5 bg-background-100 px-3 py-1.5 rounded-full">
                <i className="ri-tablet-line text-primary-500"></i>
                iPad 横屏优化
              </span>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-56 h-96 rounded-2xl overflow-hidden border-4 border-background-200 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20mobile%20phone%20mockup%20displaying%20a%20video%20streaming%20platform%20interface%2C%20warm%20coral%20and%20dark%20theme%20design%2C%20modern%20video%20player%20UI%20with%20play%20controls%20and%20thumbnails%2C%20premium%20app%20screenshot%20aesthetic%2C%20clean%20minimalist%20layout%2C%20cinematic%20atmosphere%20with%20soft%20golden%20accents%2C%20professional%20mobile%20UI%20design%20showcase&width=400&height=700&seq=app-91md-01&orientation=portrait"
                alt="91麻豆免费视频网站移动端观看界面展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}